export class ComponentValues {
  values
  constructor(values = new Map()) {
    this.values = values
  }
  static NULL = new ComponentValues()
}
